/* USAC Industrial Storefront: product page buy box.
   On variant change: price, per-piece price, part number, URL (?variant=), image,
   add-to-cart / quote state, and the pack-quantity and freight blocks. */
(function () {
  'use strict';

  var FREIGHT_GRAMS = 68039; // 150 lb

  function money(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(cents / 100);
  }

  function perPiece(cents, qty) {
    if (!qty || qty <= 1 || !cents) return '';
    var each = cents / qty;
    if (each >= 99.95) return money(Math.round(each));
    var mills = Math.round(each * 10);
    if (mills >= 1000) return money(100);
    return '$0.' + String(mills).padStart(3, '0');
  }

  function isFreight(variant) {
    return String(variant.shipping_class || '').toLowerCase() === 'truck' || (variant.weight_grams || 0) > FREIGHT_GRAMS;
  }

  function setText(root, selector, text) {
    root.querySelectorAll(selector).forEach(function (el) { el.textContent = text; });
  }

  function setHidden(root, selector, hidden) {
    root.querySelectorAll(selector).forEach(function (el) { el.hidden = hidden; });
  }

  function start(root) {
    var dataEl = root.querySelector('script[data-usac-variants]');
    var form = root.querySelector('form[data-usac-product-form]') || root.querySelector('.product-form');
    if (!dataEl || !form) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (_) { return; }
    var byId = {};
    variants.forEach(function (v) { byId[String(v.id)] = v; });
    var select = form.querySelector('select[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');

    function currentQty() {
      var n = parseInt(qtyInput && qtyInput.value, 10);
      return n > 0 ? n : 1;
    }

    function updateQtyTotal(variant) {
      var pq = variant && variant.package_quantity;
      setHidden(root, '[data-usac-qty-unit]', !(pq > 1));
      setHidden(root, '[data-usac-qty-total]', !(pq > 1));
      if (pq > 1) setText(root, '[data-usac-qty-total]', '= ' + (pq * currentQty()).toLocaleString('en-US') + ' pieces');
    }

    function update(variant, pushUrl) {
      if (!variant) return;
      var pq = variant.package_quantity || 0;
      var hasPrice = variant.price > 0;
      setText(root, '[data-usac-sku]', variant.sku || 'See available variants');
      setText(root, '[data-usac-price]', hasPrice ? money(variant.price) : 'Price on request');
      setText(root, '[data-usac-price-unit]', '/ ' + variant.title);
      setHidden(root, '[data-usac-price-unit]', !(pq > 1));
      var each = hasPrice ? perPiece(variant.price, pq) : '';
      setText(root, '[data-usac-per-piece]', each ? each + ' per piece' : '');
      setHidden(root, '[data-usac-per-piece]', !each);

      // Pack-quantity block
      root.querySelectorAll('[data-usac-pack-block]').forEach(function (block) {
        block.hidden = !(pq > 1);
        setText(block, '[data-usac-pack-title]', variant.title);
        setText(block, '[data-usac-pack-qty]', pq.toLocaleString('en-US'));
        setText(block, '[data-usac-pack-each]', each);
        setHidden(block, '[data-usac-pack-each-wrap]', !each);
      });
      // Freight block
      setHidden(root, '[data-usac-freight-block]', !isFreight(variant));

      // Buy buttons
      var quote = variant.quote_only || !variant.available;
      setHidden(root, '[data-usac-add]', quote);
      // walk62: the quote button is always shown; it is the primary action only for quote-only parts.
      var quoteHref = '/pages/contact?product=' + encodeURIComponent(variant.sku || variant.title);
      root.querySelectorAll('[data-usac-quote]').forEach(function (link) {
        link.hidden = false;
        link.classList.toggle('button-primary', quote);
        link.classList.toggle('button-outline', !quote);
        link.textContent = 'Request a quote';
        link.href = quoteHref;
      });
      root.querySelectorAll('[data-usac-eta]').forEach(function (link) { link.href = quoteHref; });

      // Image
      var img = root.querySelector('[data-usac-product-image]');
      if (img && variant.image) { img.src = variant.image; img.removeAttribute('srcset'); }

      updateQtyTotal(variant);

      // Related products section outside the buy box
      document.querySelectorAll('[data-related-products]').forEach(function (rel) { rel.dataset.productSku = variant.sku || ''; });

      if (pushUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({ variant: variant.id }, '', url.toString());
      }
    }

    if (select) {
      select.addEventListener('change', function () { update(byId[select.value], true); });
    }

    form.querySelectorAll('[data-usac-qty-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        var next = currentQty() + parseInt(button.dataset.usacQtyStep, 10);
        qtyInput.value = next < 1 ? 1 : next;
        updateQtyTotal(byId[select ? select.value : variants[0] && variants[0].id]);
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('input', function () { updateQtyTotal(byId[select ? select.value : variants[0] && variants[0].id]); });
      qtyInput.addEventListener('change', function () { qtyInput.value = currentQty(); });
    }

    // Initial sync (covers a ?variant= URL or a browser-restored selection).
    var initial = select ? byId[select.value] : variants[0];
    update(initial, false);
  }

  function boot() { document.querySelectorAll('[data-usac-product]').forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
